import { createContext } from 'react';

const WorkOrderContext = createContext();
export default WorkOrderContext;
